module.exports = __webpack_public_path__ + "static/media/15.de82059a.png";